import React from 'react'
import { useTranslation } from 'react-i18next';

const InformationModal = ({ isOpen, message, onRequestClose }) => {
    const { t } = useTranslation();

    const closeModal = () => {
        onRequestClose();
    }

    return (
        <div className="position-relative mw-500">
            <img
                src="/images/close-icon.png"
                alt="close"
                className="info-modal-close"
                onClick={onRequestClose}
            />

            <div className="info-modal-header border-bottom pb-3">
                <div className="d-flex align-items-center">
                    <img
                        src="/images/info-modal-icon.png"
                        alt="info icon"
                        className="info-modal-icon"
                    />
                    <h5 className="fw-bold mt-0 mb-0 font-18">
                        Why do we collect Age & Gender?
                    </h5>
                </div>
            </div>

            <div className="info-modal-body">
                <p className="m-0 info-modal-text small">
                    We collect age and gender information solely to provide your organisation with detailed insights into overall
                    training effectiveness and workplace trends. This data is completely confidential, anonymous, and will never
                    be shared—even with your employer. We do not store this information, and it is used only for analysis to enhance
                    workplace inclusivity and performance.
                </p>
            </div>
        </div>
    )
};

export default InformationModal;